export default __webpack_public_path__ + "static/media/VolvoNovum-Bold.1e52f576.woff";